import CircularStatProgress from './CircularStatProgress';

export default CircularStatProgress;
